// package.json
var version = "0.36.4";

// src/version.ts
var compatibilityVersion = 10;
export {
  compatibilityVersion,
  version as npmVersion
};
